import React, { useEffect, useState } from 'react';
import { AvGroup } from 'availity-reactstrap-validation';
import { FormattedMessage, useIntl } from 'react-intl';
import { Button, Label } from 'reactstrap';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { connect } from 'react-redux';
import {
  fetchPosIntegrationItemAdditionMappings,
  fetchPosIntegrationItemDataMappings,
  fetchPosIntegrationTableMappings,
  fetchPosIntegrationItemAdditionGroupMappings,
} from '../../../../redux/store/store.actions';
import {
  getItemDataOrAdditionPrice,
  getLocalizedCategoryName,
  getLocalizedDescription,
  getLocalizedName,
} from '../../../../utility/util/util.service';
import { notification } from '../../../../utility/notification/notification.service';
import classnames from 'classnames';
import { ORDER_TYPE_INHOUSE } from '../../../../utility/constants';

const PosIntegrationRefField = ({
  store,
  type, // can be item, itemAddition or table
  object,
  setter,
  options,
  isDisabled,
  me,
  posIntegrationItemDataMappings,
  posIntegrationItemAdditionMappings,
  posIntegrationItemAdditionGroupMappings,
  posIntegrationTableMappings,
  fetchPosIntegrationItemDataMappings,
  fetchPosIntegrationItemAdditionMappings,
  fetchPosIntegrationItemAdditionGroupMappings,
  fetchPosIntegrationTableMappings,
  menuEntriesData,
  additions,
  tables,
  table,
  groupClassName,
  hideButtons,
  placeholder,
  additionGroups,
  ...props
}) => {
  const intl = useIntl();
  const hasPosIntegration = store?.merchantProfile?.posIntegration;
  const [isFetched, setIsFetched] = useState(false);
  const [availableTargetOptions, setAvailableTargetOptions] = useState();
  const [targetOptions, setTargetOptions] = useState([]);

  useEffect(() => {
    setTargetOptions(
      type === 'item' || type === 'dummyItemRefs'
        ? posIntegrationItemDataMappings
        : type === 'itemAddition'
        ? posIntegrationItemAdditionMappings
        : type === 'table'
        ? posIntegrationTableMappings
        : type === 'itemAdditionGroup'
        ? posIntegrationItemAdditionGroupMappings
        : [],
    );
    if (type === 'item' && posIntegrationItemDataMappings) {
      const updatedMappings = posIntegrationItemDataMappings.map(
        (posIntegrationItemDataMapping) => {
          const foundPosIntegrationRef = menuEntriesData?.find(
            (menuEntryData) =>
              menuEntryData?.posIntegrationRef ===
              posIntegrationItemDataMapping?.posIntegrationRef,
          );
          return {
            ...posIntegrationItemDataMapping,
            isAlreadyUsed: Boolean(foundPosIntegrationRef),
          };
        },
      );
      setAvailableTargetOptions(updatedMappings);
    }

    if (type === 'dummyItemRefs' && posIntegrationItemDataMappings) {
      const updatedMappings = posIntegrationItemDataMappings.map(
        (posIntegrationItemDataMapping) => {
          const foundPosIntegrationRef = menuEntriesData?.find(
            (menuEntryData) =>
              menuEntryData?.posIntegrationRef ===
              posIntegrationItemDataMapping?.posIntegrationRef,
          );
          return {
            ...posIntegrationItemDataMapping,
            isAlreadyUsed: Boolean(foundPosIntegrationRef),
          };
        },
      );
      setAvailableTargetOptions(updatedMappings);
    }

    if (type === 'itemAddition') {
      const updatedMappings = posIntegrationItemAdditionMappings?.map(
        (posIntegrationItemAdditionMapping) => {
          const foundPosIntegrationRef = additions?.find(
            (addition) =>
              addition?.posIntegrationRef ===
              posIntegrationItemAdditionMapping?.posIntegrationRef,
          );
          return {
            ...posIntegrationItemAdditionMapping,
            isAlreadyUsed: Boolean(foundPosIntegrationRef),
          };
        },
      );
      setAvailableTargetOptions(updatedMappings);
    }

    if (type === 'itemAdditionGroup') {
      const updatedMappings = posIntegrationItemAdditionGroupMappings?.map(
        (posIntegrationItemAdditionGroupMapping) => {
          const foundPosIntegrationRef = additionGroups?.find(
            (additionsGroup) =>
              additionsGroup?.posIntegrationRef ===
              posIntegrationItemAdditionGroupMapping?.posIntegrationRef,
          );
          return {
            ...posIntegrationItemAdditionGroupMapping,
            isAlreadyUsed: Boolean(foundPosIntegrationRef),
          };
        },
      );
      setAvailableTargetOptions(updatedMappings);
    }

    if (type === 'table') {
      const updatedMappings = posIntegrationTableMappings?.map(
        (posIntegrationTableMapping) => {
          const foundPosIntegrationRef = tables?.find(
            (table) =>
              table?.posIntegrationRef ===
              posIntegrationTableMapping?.posIntegrationRef,
          );
          return {
            ...posIntegrationTableMapping,
            isAlreadyUsed: Boolean(foundPosIntegrationRef),
          };
        },
      );
      setAvailableTargetOptions(updatedMappings);
    }
  }, [
    type,
    posIntegrationItemAdditionGroupMappings,
    posIntegrationItemDataMappings,
    posIntegrationItemAdditionMappings,
    posIntegrationTableMappings,
    fetchPosIntegrationItemAdditionMappings,
    fetchPosIntegrationItemAdditionGroupMappings,
    fetchPosIntegrationTableMappings,
  ]);

  const dot = (color = 'transparent') => ({
    alignItems: 'center',
    display: 'flex',

    ':before': {
      backgroundColor: color,
      borderRadius: 10,
      content: '" "',
      display: 'block',
      marginRight: 8,
      height: 10,
      width: 10,
      minWidth: 10,
    },
  });

  const colourStyles = {
    singleValue: (styles, { data }) => ({
      ...styles,
      ...(type !== 'dummyItemRefs'
        ? data?.isAlreadyUsed
          ? dot('#dc2839')
          : dot('#22442c')
        : null),
    }),
    option: (styles, { data }) => ({
      ...styles,
      ...(type !== 'dummyItemRefs'
        ? data?.isAlreadyUsed && type !== 'dummyItemRefs'
          ? dot('#dc2839')
          : dot('#22442c')
        : null),
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    menu: (base) => ({ ...base, zIndex: 9999 }),
  };
  useEffect(() => {
    if (me && !targetOptions && !isFetched) {
      setIsFetched(true);
      const posIntegrationId =
        me.requester.employeeProfile?.store?.merchantProfile?.posIntegration
          ?.id;

      if (posIntegrationId) {
        switch (type) {
          case 'item':
          case 'dummyItemRefs':
            fetchPosIntegrationItemDataMappings(posIntegrationId);
            break;
          case 'itemAddition':
            fetchPosIntegrationItemAdditionMappings(posIntegrationId);
            break;
          case 'itemAdditionGroup':
            fetchPosIntegrationItemAdditionGroupMappings(posIntegrationId);
            break;
          case 'table':
            fetchPosIntegrationTableMappings(posIntegrationId);
            break;
          default:
            console.error(`Unknown type "${type}"`);
        }
      } else {
        console.error(`No PosIntegration found`);
      }
    }
  });

  return (
    hasPosIntegration ? (
      <div className={type === 'dummyItemRefs' && 'pt-1'}>
        <AvGroup
          data-testid="posIntegrationRef"
          className={classnames(
            'react-select form-label-group',
            groupClassName,
          )}
        >
          <Select
            id={object?.id}
            isMulti={type === 'dummyItemRefs'}
            isClearable={true}
            isDisabled={isDisabled}
            isLoading={!availableTargetOptions}
            name="posIntegrationRef"
            styles={colourStyles}
            noOptionsMessage={() =>
              intl.formatMessage({ id: 'noPosIntegrationRefAvailableToSelect' })
            }
            className={'react-select-container'}
            classNamePrefix={'react-select'}
            value={
              type === 'dummyItemRefs'
                ? availableTargetOptions?.filter(({ posIntegrationRef }) =>
                    object?.dummyItemRefs?.includes(posIntegrationRef),
                  )
                : availableTargetOptions?.find(
                    ({ posIntegrationRef }) =>
                      posIntegrationRef === object?.posIntegrationRef,
                  )
            }
            getOptionLabel={(option) => {
              const isTable = type === 'table';
              const isAdditionGroup = type === 'itemAdditionGroup';
              const name = getLocalizedName(option, intl.locale);
              /*const description = getLocalizedDescription(option, intl.locale);*/
              const priceInhouse = intl.formatNumber(
                getItemDataOrAdditionPrice(ORDER_TYPE_INHOUSE, option),
                { format: 'priceCurrency' },
              );
              const categoryName =
                type === 'itemAddition' &&
                getLocalizedCategoryName(option, intl.locale);
              const ref = option.posIntegrationRef;

              // build the label
              return [
                !isTable && categoryName && `${categoryName}:`,
                !isTable && name,
                !isTable &&
                  !isAdditionGroup &&
                  priceInhouse &&
                  `(${priceInhouse})`,
                !isTable && ref && `[${ref}]`,
                isTable && option.name,
              ]
                .filter(Boolean)
                .join(' ');
            }}
            getOptionValue={({ posIntegrationRef }) => posIntegrationRef}
            onChange={(option) => {
              setter({
                ...object,
                ...(type === 'dummyItemRefs'
                  ? {
                      dummyItemRefs:
                        option?.map(
                          ({ posIntegrationRef }) => posIntegrationRef,
                        ) || null,
                    }
                  : { posIntegrationRef: option?.posIntegrationRef || '' }),
              });
            }}
            placeholder={
              placeholder ||
              intl.formatMessage({ id: 'defaultDropdownPlaceholder' })
            }
            options={availableTargetOptions || []}
            menuPortalTarget={document.body}
            menuPosition="fixed"
            {...props}
          />
          <Label className="floating-label" for={object?.id}>
            <FormattedMessage
              id={
                type === 'dummyItemRefs'
                  ? 'dummyItemsLabel'
                  : 'posIntegrationRefTitle'
              }
            />
          </Label>
          {(type === 'item' || type === 'itemAddition') && (
            <div className="mt-50">
              <Button
                data-testid="applyAllButton"
                size="sm"
                color="secondary"
                className="mr-50"
                onClick={() => {
                  const targetOption = targetOptions?.find(
                    ({ posIntegrationRef }) =>
                      posIntegrationRef === object?.posIntegrationRef,
                  );

                  if (targetOption) {
                    setter({
                      ...object,
                      ...targetOption,
                    });
                    notification(
                      'success',
                      intl.formatMessage(
                        {
                          id: 'posIntegrationApplyAllNotification',
                        },
                        { itemName: getLocalizedName(object, intl.locale) },
                      ),
                    );
                  }
                }}
              >
                <FormattedMessage id="posIntegrationApplyAllLabel" />
              </Button>
              <Button
                data-testid="applyPriceTaxButton"
                size="sm"
                color="secondary"
                onClick={() => {
                  const targetOption = targetOptions?.find(
                    ({ posIntegrationRef }) =>
                      posIntegrationRef === object?.posIntegrationRef,
                  );

                  if (targetOption) {
                    setter({
                      ...object,
                      priceInhouse: targetOption.priceInhouse,
                      taxInhouse: targetOption.taxInhouse,
                      priceTakeaway: targetOption.priceTakeaway,
                      taxTakeaway: targetOption.taxTakeaway,
                    });
                    notification(
                      'success',
                      intl.formatMessage(
                        {
                          id: 'posIntegrationApplyPriceTaxNotification',
                        },
                        { itemName: getLocalizedName(object, intl.locale) },
                      ),
                    );
                  }
                }}
              >
                <FormattedMessage id="posIntegrationApplyPriceTaxLabel" />
              </Button>
            </div>
          )}
        </AvGroup>
        {type === 'dummyItemRefs' && (
          <span className="d-block font-small-2">
            <FormattedMessage id="dummyItemsText" />
          </span>
        )}
      </div>
    ) : <></>
  );
};

PosIntegrationRefField.propTypes = {
  object: PropTypes.object,
  setter: PropTypes.func,
  options: PropTypes.array,
  isDisabled: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  me: state.me.me,
  posIntegrationItemDataMappings: state.store.posIntegrationItemDataMappings,
  posIntegrationItemAdditionMappings:
    state.store.posIntegrationItemAdditionMappings,
  posIntegrationItemAdditionGroupMappings:
    state.store.posIntegrationItemAdditionGroupMappings,
  posIntegrationTableMappings: state.store.posIntegrationTableMappings,
  store: state.store.store,
  menuEntriesData: state.store.menuEntriesData,
  additions: state.store.foodItemAdditions,
  tables: state.store.tables,
  table: state.store.table,
  additionGroups: state.store.additionGroups,
});

export default connect(mapStateToProps, {
  fetchPosIntegrationItemDataMappings,
  fetchPosIntegrationItemAdditionMappings,
  fetchPosIntegrationTableMappings,
  fetchPosIntegrationItemAdditionGroupMappings,
})(PosIntegrationRefField);
